import { useState } from "react";
import HollowButton from "../../components/customComponents/HallowButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { setPaymentSettingModal } from "../../reducer/modalReducer";
import PaymentSettingModal from "../../components/Modal/PaymentSettingModal";

export default function PATPaymentSettingSection() {
  const dispatch = useDispatch();
  const { paymentFrequency, commisionRate, currency } = useSelector(
    (state: RootState) => state.registration
  );

  const handleEditButtonClick = () => {
    dispatch(setPaymentSettingModal(true));
  };

  return (
    <div className={Classname.container}>
      <PaymentSettingModal />
      <div className={Classname.flexBetween}>
        <div className="font-semibold mb-3">Payment settings</div>
        <HollowButton label="Edit" onClick={handleEditButtonClick} />
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Payment frequency</div>
        {paymentFrequency ? (
          <div>{paymentFrequency}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>Commission rate</div>
        {commisionRate ? (
          <div>{commisionRate}%</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>Currency</div>
        {currency ? (
          <div>{currency}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
    </div>
  );
}

const Classname = {
  container: "bg-white pb-10 rounded-md p-2 h-fit gap-3 flex flex-col lg:px-10",
  flexBetween: "flex justify-between mt-5",
  title: "font-bold w-56",
  listContainer: "flex lg:gap-32 flex-col lg:flex-row",
  unspecified: "text-red-500 ",
};
